import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import { getDobDate, getDodDate } from "../../common/DisplayDate";
import getSsn from "../../common/Ssn";
import getPersonName from "../../common/Name";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

const getRelativeDetails = (props, record, relIndex, innerRelIndex) => {
  const relRows = [];
  let header = "";
  if (record !== undefined) {
    header = `${_.get(
      record,
      "AKAs[0].identity[0].name[0].first[0]._",
      ""
    )} ${_.get(record, "AKAs[0].identity[0].name[0].middle[0]._", "")} ${_.get(
      record,
      "AKAs[0].identity[0].name[0].last[0]._",
      ""
    )}`;
    const DOB = getDobDate(_.get(record, "AKAs[0].identity[0].DOB[0]"), {
      userAccount: props.userAccount,
    });

    if (_.get(record, "AKAs[0].identity[0].SSNInfo[0]") !== undefined) {
      relRows.push(
        <Table.Row key={`ssn_info_${relIndex}_${innerRelIndex}`}>
          <Table.Cell width={6}>
            SSN:{" "}
            {getSsn(
              _.get(record, "AKAs[0].identity[0].SSNInfo[0].SSN[0]._", ""),
              props
            )}
          </Table.Cell>
          <Table.Cell width={7}>
            Issued:{" "}
            {_.get(
              record,
              "AKAs[0].identity[0].SSNInfo[0].issuedStartDate[0].year[0]._",
              ""
            )}{" "}
            {_.get(
              record,
              "AKAs[0].identity[0].SSNInfo[0].issuedLocation[0]._",
              ""
            )}
          </Table.Cell>
          <Table.Cell width={3} />
        </Table.Row>
      );
    }
    relRows.push(
      <Table.Row key={`relatives_dob_${relIndex}_${innerRelIndex}`}>
        <Table.Cell width={6}>DOB: {DOB}</Table.Cell>
        <Table.Cell width={7}>
          Age: {_.get(record, "AKAs[0].identity[0].age[0]._", "")}
        </Table.Cell>
        <Table.Cell width={3} />
      </Table.Row>
    );

    const baseIdentity = _.get(record, "AKAs[0].identity[0]");
    const dod = _.get(baseIdentity, "DOD[0]");
    if (dod !== undefined) {
      relRows.push(
        <Table.Row key={`relatives_dod_${relIndex}_${innerRelIndex}`}>
          <Table.Cell width={6}>
            Deceased Date: {getDodDate(dod, { userAccount: props.userAccount })}
          </Table.Cell>
          <Table.Cell width={7}>
            Age At Death: {_.get(baseIdentity, "ageAtDeath[0]._", "")}
          </Table.Cell>
          <Table.Cell width={3} />
        </Table.Row>
      );
    }
    const deceasedState = _.get(baseIdentity, "deceasedState[0]._", "");
    const deceasedCounty = _.get(baseIdentity, "deceasedCounty[0]._", "");
    if (deceasedState !== "" || deceasedCounty !== "") {
      relRows.push(
        <Table.Row key={`relatives_dod_st_cnty_${relIndex}_${innerRelIndex}`}>
          <Table.Cell width={6}>Deceased State: {deceasedState}</Table.Cell>
          <Table.Cell width={7}>Deceased County: {deceasedCounty}</Table.Cell>
          <Table.Cell width={3} />
        </Table.Row>
      );
    }
    const deathState = _.get(baseIdentity, "deathState[0]._", "");
    const deathCounty = _.get(baseIdentity, "deathCounty[0]._", "");
    if (deathState !== "" || deathCounty !== "") {
      relRows.push(
        <Table.Row
          key={`relatives_dod_dth_st_cnty_${relIndex}_${innerRelIndex}`}
        >
          <Table.Cell width={6}>Deceased State: {deathState}</Table.Cell>
          <Table.Cell width={7}>Deceased County: {deathCounty}</Table.Cell>
          <Table.Cell width={3} />
        </Table.Row>
      );
    }
    const identities = _.get(record, "AKAs[0].identity");
    _.forEach(identities, (identity, index) => {
      relRows.push(
        <Table.Row key={`identity_row_${relIndex}_${innerRelIndex}_${index}`}>
          <Table.Cell width={10} colSpan={2}>
            AKA:{" "}
            {getPersonName(
              _.get(identity, "name[0].first[0]._", ""),
              _.get(identity, "name[0].middle[0]._", ""),
              _.get(identity, "name[0].last[0]._", ""),
              props
            )}
          </Table.Cell>
          <Table.Cell width={3} />
        </Table.Row>
      );
    });

    const addressInfos = _.get(record, "addresses[0].address");
    _.forEach(addressInfos, (addressdetails, addIndex) => {
      relRows.push(
        <Table.Row
          key={`address_row_${relIndex}_${innerRelIndex}_${addIndex}`}
          className={addIndex % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell width={3}>Address:</Table.Cell>
          <Table.Cell width={7}>
            <Address
              addressNode={addressdetails.address[0]}
              noBreakIconsAndText
              {...props}
            />
          </Table.Cell>

          <Table.Cell width={6}>
            Dates of occupancy:{" "}
            {_.get(addressdetails, "dateFirstSeen[0].year[0]._")} -
            {_.get(addressdetails, "dateLastSeen[0].year[0]._")}
            {_.get(addressdetails, "shared[0]._", "") === "true" ? (
              <b> Shared Address</b>
            ) : (
              ""
            )}
          </Table.Cell>
        </Table.Row>
      );

      const phoneInfo = _.get(addressdetails, "phones[0].phone[0]");
      if (phoneInfo !== undefined) {
        const contact = _.get(phoneInfo, "listingName[0]._", "");
        const tokens = contact.split(" ");
        relRows.push(
          <Table.Row
            width={3}
            key={`contact_row_${relIndex}_${innerRelIndex}_${addIndex}`}
            className={addIndex % 2 === 1 ? "table-row-odd-child" : ""}
          >
            <Table.Cell>Contact: </Table.Cell>
            <Table.Cell width={7}>
              {getPersonName(
                tokens && tokens.length > 1 ? tokens[1] : "",
                "",
                tokens && tokens.length > 0 ? tokens[0] : "",
                props
              )}
            </Table.Cell>
            <Table.Cell width={6}>
              Phones: {_.get(addressdetails, "phones[0].phone[0].phone10[0]._")}
            </Table.Cell>
          </Table.Row>
        );
      }

      const nameInfos = _.get(addressdetails, "residents[0].identity");
      _.forEach(nameInfos, (nameInfo, index) => {
        const age = _.get(nameInfo, "age[0]._", "");
        const dodYear = _.get(nameInfo, "DOD[0].year[0]._", "");
        relRows.push(
          <Table.Row
            key={`phone_row_${relIndex}_${addIndex}_${innerRelIndex}_${index}`}
            className={addIndex % 2 === 1 ? "table-row-odd-child" : ""}
          >
            <Table.Cell width={3} />
            <Table.Cell width={7}>
              Name:{" "}
              {getPersonName(
                _.get(nameInfo, "name[0].first[0]._", ""),
                _.get(nameInfo, "name[0].middle[0]._", ""),
                _.get(nameInfo, "name[0].last[0]._", ""),
                props
              )}
              {age !== "" ? ` Age: ${age}` : ""}
              {dodYear !== "" ? ` DOD: ${dodYear}` : ""}
            </Table.Cell>
            <Table.Cell />
          </Table.Row>
        );
        if (dod !== undefined) {
          relRows.push(
            <Table.Row
              key={`dod_row_1_${relIndex}_${addIndex}_${innerRelIndex}_${index}`}
              className={index % 2 === 1 ? "table-row-odd-child" : ""}
            >
              <Table.Cell width={3}>Deceased Date: </Table.Cell>
              <Table.Cell width={7}>
                {age !== "" ? ` Age: ${age}` : ""}
                {dodYear !== "" ? ` DOD: ${dodYear}` : ""}
              </Table.Cell>
              <Table.Cell />
            </Table.Row>
          );
        }
      });
    });
    const innerRecords = _.get(record, "relatives[0].relative");
    const innerRows = [];
    if (innerRecords !== undefined && innerRecords.length > 0) {
      _.forEach(innerRecords, (innerRecord, inRelIndex) => {
        innerRows.push(
          <Table.Row
            key={`relatives_inner_body_${relIndex}_${innerRelIndex}_${inRelIndex}`}
          >
            <Table.Cell colSpan={3}>
              {getRelativeDetails(props, innerRecord, relIndex, inRelIndex)}
            </Table.Cell>
          </Table.Row>
        );
      });
      if (innerRows.length > 0) {
        relRows.push(
          <Table.Row
            key={`relatives_inner_header_${relIndex}_${innerRelIndex}`}
          >
            <Table.Cell colSpan={3}>
              <SimpleAccordionContent
                {...this.props}
                name={`Relatives of ${header}`}
                rows={innerRows}
              />
            </Table.Cell>
          </Table.Row>
        );
      }
    }
  }
  return (
    <SimpleAccordionContent
      key={`relative_table_${relIndex}`}
      {...this.props}
      name={header}
      rows={relRows}
    />
  );
};

export default getRelativeDetails;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/RelativeDetails.js